webpackJsonp([62057608682250],{

/***/ 1916:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"PatientRdvm","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"insertedAt","type":{"kind":"SCALAR","name":"NaiveDateTime","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"isPreferred","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"notes","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"rdvm","type":{"kind":"OBJECT","name":"Rdvm","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"referringDoctors","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":"A patient's RDVM assignment with patient-specific fields","enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-patient-rdvm-dca79d4349d8941d9f29.js